import { render, staticRenderFns } from "./ParaYatirmaSorunlari.vue?vue&type=template&id=f2774d5a&scoped=true"
import script from "./ParaYatirmaSorunlari.vue?vue&type=script&lang=js"
export * from "./ParaYatirmaSorunlari.vue?vue&type=script&lang=js"
import style0 from "./ParaYatirmaSorunlari.vue?vue&type=style&index=0&id=f2774d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2774d5a",
  null
  
)

export default component.exports